import { injectable } from 'inversify';
import { resolve } from '../../Container';
import { Overlay, OverlayHandle, OverlayLayout, OverlayPaint } from './Overlay';
import { OverlayComposition } from './OverlayComposition';

@injectable()
export class OverlayManager {

    @resolve(OverlayComposition) private composition!: OverlayComposition;

    public createOverlay(id: string, paint: OverlayPaint): OverlayHandle;
    public createOverlay(id: string, layout: OverlayLayout, paint: OverlayPaint): OverlayHandle;
    public createOverlay(...args: any[]): OverlayHandle {
        if (args.length === 2) return this.createOverlay(args[0], null, args[1]);
        const [id, layout, paint] = args;
        return new Overlay(id, layout, paint);
    }

    public add(overlay: OverlayHandle) {
        if (overlay instanceof Overlay) {
            return this.composition.add(overlay);
        }
        return false;
    }

    public remove(overlay: OverlayHandle): boolean {
        if (overlay instanceof Overlay) {
            return this.composition.remove(overlay);
        }
        return false;
    }
}
